export default __webpack_public_path__ + "static/media/emoji_newspaper.b5ee81ee.svg";